'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _isUndefined2 = require('lodash/isUndefined');

var _isUndefined3 = _interopRequireDefault(_isUndefined2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _audioplayer = require('redux/modules/audioplayer');

var audioPlayerActions = _interopRequireWildcard(_audioplayer);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _AudioPlayer = require('helpers/AudioPlayer');

var _AudioPlayer2 = _interopRequireDefault(_AudioPlayer);

var _Spectrum = require('components/Spectrum/Spectrum');

var _Spectrum2 = _interopRequireDefault(_Spectrum);

var _TrackPlayPauseLockedButton = require('./TrackPlayPauseLockedButton');

var _TrackPlayPauseLockedButton2 = _interopRequireDefault(_TrackPlayPauseLockedButton);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TrackPlayPauseButton.scss');

var TrackPlayPauseButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    currentTrackIndex: state.audioplayer.currentTrackIndex,
    playerAlbum: state.audioplayer.album,
    playerStatus: state.audioplayer.playerStatus,
    playerTracks: state.audioplayer.tracks
  };
}, (0, _extends3.default)({}, audioPlayerActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(TrackPlayPauseButton, _Component);

  function TrackPlayPauseButton() {
    (0, _classCallCheck3.default)(this, TrackPlayPauseButton);
    return (0, _possibleConstructorReturn3.default)(this, (TrackPlayPauseButton.__proto__ || (0, _getPrototypeOf2.default)(TrackPlayPauseButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(TrackPlayPauseButton, [{
    key: 'getRenderProps',
    value: function getRenderProps() {
      var _props = this.props,
          currentTrackIndex = _props.currentTrackIndex,
          playerTracks = _props.playerTracks,
          playerStatus = _props.playerStatus,
          track = _props.track,
          album = _props.album,
          playerAlbum = _props.playerAlbum,
          trackNumber = _props.trackNumber;

      var currentPlayerTrack = playerTracks[currentTrackIndex] || {};

      var _audioplayer$getPlayi = _AudioPlayer2.default.getPlayingInfo({
        track: track, album: album, playerAlbum: playerAlbum, currentPlayerTrack: currentPlayerTrack, playerStatus: playerStatus
      }),
          isActiveTrack = _audioplayer$getPlayi.isActiveTrack,
          isPlayerPlaying = _audioplayer$getPlayi.isPlayerPlaying,
          isTrackPlaying = _audioplayer$getPlayi.isTrackPlaying;

      var buttonClass = (0, _bind2.default)(isTrackPlaying ? 'icon-pause' : 'icon-play', styles.playerIcon);
      var displayedTrackNumber = !(0, _isUndefined3.default)(trackNumber) ? trackNumber : track.track_number;
      return { displayedTrackNumber: displayedTrackNumber, buttonClass: buttonClass, isActiveTrack: isActiveTrack, isPlayerPlaying: isPlayerPlaying };
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          showSpectrum = _props2.showSpectrum,
          showTrackNumber = _props2.showTrackNumber,
          className = _props2.className,
          isDenied = _props2.isDenied;

      var _getRenderProps = this.getRenderProps(),
          displayedTrackNumber = _getRenderProps.displayedTrackNumber,
          buttonClass = _getRenderProps.buttonClass,
          isActiveTrack = _getRenderProps.isActiveTrack,
          isPlayerPlaying = _getRenderProps.isPlayerPlaying;

      return _react2.default.createElement(
        'span',
        { className: (0, _bind2.default)((0, _defineProperty3.default)({}, styles.withSpectrum, showSpectrum), className) },
        isDenied ? _react2.default.createElement(_TrackPlayPauseLockedButton2.default, null) : isActiveTrack ? showSpectrum ? _react2.default.createElement(_Spectrum2.default, { isActive: isPlayerPlaying }) : _react2.default.createElement('i', { className: buttonClass }) : showTrackNumber ? displayedTrackNumber : _react2.default.createElement('i', { className: buttonClass })
      );
    }
  }]);
  return TrackPlayPauseButton;
}(_react.Component), _class2.propTypes = {
  album: _propTypes2.default.object,
  className: _propTypes2.default.string,
  currentTrackIndex: _propTypes2.default.number,
  isDenied: _propTypes2.default.bool,
  playerAlbum: _propTypes2.default.object,
  playerStatus: _propTypes2.default.string,
  playerTracks: _propTypes2.default.array,
  showSpectrum: _propTypes2.default.bool,
  showTrackNumber: _propTypes2.default.bool,
  track: _propTypes2.default.object,
  trackNumber: _propTypes2.default.number
}, _class2.defaultProps = {
  album: {},
  playerAlbum: {},
  showSpectrum: true,
  track: {}
}, _temp)) || _class);
exports.default = TrackPlayPauseButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TrackPlayPauseButton/TrackPlayPauseButton.js
// module id = 857
// module chunks = 1